import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"rewind"} maskId="square-filled-radius-0-stroke-1-IconRewind"><path d="M19.9991 19.9897V4.01074L11.9991 9.90548V4.01074L1.15625 12.0002L11.9991 19.9897V14.095L19.9991 19.9897Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconRewind;
